import { capitalizarPrimeraLetra } from '../../utils'
import { updateListMethod } from '../../utils/list'
import {
  ASSESSMENT_TOGGLE_LOADING,
  ASSESSMENT_UPDATE_CURRICULUM,
  ASSESSMENT_UPDATE_CURRICULUM_METHOD,
  ASSESSMENT_UPDATE_ERROR,
  ASSESSMENT_CURRENT_CURRICULUM,
  ASSESSMENT_SET_CURRENT_LEARNING_AREA
} from '../actions/assessment.actions'

const initialState = {
  loading: false,
  error: null,
  curriculum: [],
  currentCurriculum: null,
  learningAreas: [],
  currentLearningArea: null
}

const mapLearningAreas = (curriculum) => {
  const learningAreas = []
  curriculum.forEach((curr) => {
    const base = {
      curriculumId: curr._id,
      curriculumName: curr.name,
      curriculumCode: curr.shortName
    }
    curr.elements.children.forEach((child) => {
      learningAreas.push({
        ...base,
        elementStructureId: curr.elements.elementStructureId,
        name: child.name,
        _id: child._id,
        shortName: child.shortName,
        primaryColor: child.primaryColor,
        secondaryColor: child.secondaryColor,
        icon: child.icon
      })
    })
  })

  let currentLearningArea = learningAreas[0] || null
  if (learningAreas.length > 0) {
    if (learningAreas.some(({ curriculumCode }) => ['VIC', 'VCV2'].includes(curriculumCode))) {
      if (
        learningAreas.some(
          ({ name, curriculumCode }) => ['English'].includes(name) && ['VIC', 'VCV2'].includes(curriculumCode)
        )
      ) {
        currentLearningArea = learningAreas.find(
          ({ name, curriculumCode }) => ['English'].includes(name) && ['VIC', 'VCV2'].includes(curriculumCode)
        )
      } else {
        currentLearningArea = learningAreas.find(({ curriculumCode }) =>
          ['VIC', 'VCV2'].includes(curriculumCode)
        )
      }
    } else if (learningAreas.some(({ name }) => ['English'].includes(name))) {
      currentLearningArea = learningAreas.find(({ name }) => ['English'].includes(name))
    }
  }
  return { learningAreas, currentLearningArea }
}

const assessmentReducer = (state = initialState, action) => {
  const newState = { ...state }
  const { type, payload } = action

  switch (type) {
    case ASSESSMENT_TOGGLE_LOADING:
      newState.loading = payload.loading
      break
    case ASSESSMENT_UPDATE_CURRICULUM: {
      newState.curriculum = payload.curriculum
      const { learningAreas, currentLearningArea } = mapLearningAreas(payload.curriculum)

      newState.learningAreas = learningAreas
      newState.currentLearningArea = currentLearningArea
      break
    }
    case ASSESSMENT_UPDATE_CURRICULUM_METHOD:
      newState.curriculum = updateListMethod(payload.method, payload.curriculum, newState.curriculum)

      break
    case ASSESSMENT_UPDATE_ERROR:
      newState.error = payload.error
      break
    case ASSESSMENT_CURRENT_CURRICULUM:
      if (['unassigned', 'assigned', 'all'].includes(payload.curriculumId)) {
        newState.currentCurriculum = {
          shortName: payload.curriculumId,
          name: capitalizarPrimeraLetra(payload.curriculumId),
          _id: payload.curriculumId
        }
      } else {
        newState.currentCurriculum = newState.curriculum.find(
          ({ _id }) => String(_id) === String(payload.curriculumId)
        )
      }
      break
    case ASSESSMENT_SET_CURRENT_LEARNING_AREA:
      newState.currentLearningArea = newState.learningAreas.find(
        ({ _id }) => String(_id) === String(payload.learningAreaId)
      )
      break
    default:
      break
  }

  return newState
}

export default assessmentReducer
